import React, { useState } from "react";
import CustomModal from "./CustomModal";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import MainInput from "../common/MainInput";
import PhoneInput from "../common/PhoneInput";
import GiftCard from "../../assets/GiftCard.svg";
import CustomModalForRegistration from "./CustomModalForRegistration";

type RegistrationModalProps = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: ({
    firstname,
    lastname,
    email,
    phone,
  }: {
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
  }) => void;
  onRegister?: ({
    first_name,
    last_name,
    email,
    phone,
  }: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
  }) => void;
  trackItem: (eventname: string) => void;
};

const RegistrationModal: React.FC<RegistrationModalProps> = ({
  modalVisible,
  setModalVisible,
  onSubmit,
  onRegister,
  trackItem,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    // Validate the required fields
    if (!firstName.trim() || !lastName.trim() || !email.trim()) {
      setError("First name, last name, and email are required");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.match(emailRegex)) {
      setError("Invalid email format");
      return;
    }

    let pattern = /^\d{10}$/;

    if (pattern.test(phone)) {
    } else if (phone.length < 10) {
      setError("Phone number is too short");
      return;
    } else {
      setError("Phone number is too long");
      return;
    }

    onSubmit({
      firstname: firstName,
      lastname: lastName,
      email: email,
      phone: phone,
    });
    // onSubmit({
    //   first_name: firstName,
    //   last_name: lastName,
    //   email: email,
    // });

    // Add your form submission logic here
    setModalVisible(false);
  };

  const handleOnFocus = () => {
    setError("");
  };

  return (
    <CustomModalForRegistration
      modalVisible={modalVisible}
      height="500px"
      setModalVisible={() => {}}
    >
      <div className="modalContainer itemsCenter">
        <CustomText
          color={Colors.primary}
          size="small"
          weight="700"
          marginTop={30}
          textAlign="center"
        >
          Enter your info to submit your picks.
        </CustomText>
        <CustomText
          color={Colors.blueGray}
          size="small"
          weight="500"
          marginTop={5}
          marginBottom={10}
          textAlign="center"
        >
          Top players win AJIO E-Gift Cards!
        </CustomText>
        <div className="otherForm">
          <div className="flex flexColumn space-y-4">
            <MainInput
              label="First Name"
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
              onFocus={handleOnFocus}
              onBlur={() => {
                if (firstName) trackItem("Firstname Filled");
              }}
            />
            <MainInput
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              onFocus={handleOnFocus}
              onBlur={() => {
                if (lastName) trackItem("LastName Filled");
              }}
            />
            <MainInput
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value.trim())}
              onFocus={handleOnFocus}
              onBlur={() => {
                if (email) trackItem("Email Filled");
              }}
            />
            <PhoneInput
              label="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={handleOnFocus}
              onBlur={() => {
                if (phone) trackItem("Phone Filled");
              }}
            />
            {error && (
              <CustomText
                textAlign="center"
                marginTop={10}
                color={Colors.error}
              >
                {error}
              </CustomText>
            )}
            <button
              className="buttonRegistrationSubmitButton"
              onMouseDown={() => {
                handleSubmit();
                trackItem("Registration Button Clicked.");
              }}
              // onMouseDown={() => {
              //   onSubmit({
              //     firstname: firstName,
              //     lastname: lastName,
              //     email: email,
              //   });
              // }}
            >
              <CustomText color={Colors.white} size="smallMedium" weight="700">
                SUBMIT
              </CustomText>
            </button>
          </div>
        </div>
      </div>
    </CustomModalForRegistration>
  );
};

export default RegistrationModal;
